module.exports = __webpack_public_path__ + "img/notBL.6c184d30.png";